import React from 'react';

interface SubmitButtonProps {
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  disable?: boolean;
  width?: string;
  bgColor?: string;
  textColor?: string;
  hoverBorderColor?: string;
  bgColorHover?: string;
  textColorHover?: string;
  textSize?: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ( {
  label,
  icon,
  onClick,
  disable = false,
  bgColor = 'bg-green-base',
  textColor = 'text-green-800',
  hoverBorderColor = 'group-hover:border-green-base',
  bgColorHover = 'group-hover:bg-green-800',
  textColorHover = 'group-hover:text-green-base',
  textSize = 'text-base',
  width = 'w-full',
} ) => {
  return (
    <button
      className={`h-fit ${width} flex-center group ${disable ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={disable ? undefined : onClick}
    >
      <div
        className={`
          py-3 flex-center flex group-hover:-translate-y-1 px-5 trans-fast border-b-2 border-transparent rounded-md shadow-md w-full ${textSize}
          ${disable ? 'bg-gray-300 text-white group-hover:text-gray-500 group-hover:border-gray-500 group-hover:bg-gray-200' : `${bgColor} ${textColor} ${bgColorHover} ${textColorHover} ${hoverBorderColor}`}
        `}
      >
        {icon && (
          <span className="trans-lessfast group-hover:rotate-[360deg] mr-5 select-none">
            {icon}
          </span>
        )}
        <p className="trans-fast whitespace-nowrap select-none">{label}</p>
      </div>
    </button>
  );
};

export default SubmitButton;
